import '@fortawesome/fontawesome-free/css/all.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';
import { VCard, VCardTitle, VCardSubtitle, VRow, VCol, VTextField, VTextarea, VAutocomplete, VTooltip, VCheckbox, VCombobox, VSelect, VSwitch, VBtn, VBtnToggle, VFileInput, VSlider, VRadio, VRadioGroup, VDatePicker, VTimePicker, VMenu, VSpacer, VSubheader, VIcon, VImg } from 'vuetify/lib';
import { Ripple, Intersect, Touch, Resize, ClickOutside } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  components: { VCard, VCardTitle, VCardSubtitle, VRow, VTooltip, VCol, VTextField, VAutocomplete, VTextarea, VCheckbox, VCombobox, VSelect, VSwitch, VBtn, VBtnToggle, VFileInput, VSlider, VRadio, VRadioGroup, VDatePicker, VTimePicker, VMenu, VSpacer, VSubheader, VIcon, VImg },
  directives: { Ripple, Intersect, Touch, Resize, ClickOutside }
});

export default new Vuetify({
  icons: {
    iconfont: 'md' || 'fa'
  },
  theme: {
    themes: {
      light: {
        primary: colors.orange.darken2,
        secondary: colors.blue.darken2,
      },
    },
  }
});
